module.exports = __webpack_public_path__ + "img/20191219144418062.3311c1b2.jpg";